/**
=========================================================
* MD UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/MD-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the MDware.
*/
import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import { useAppServices } from 'hook/services'
import { useEffect, useState } from 'react'
import EditModal from '../../EditModal'
import CreateModal from '../../CreateModal'

export default function DataTableData(appId) {
  const AppService = useAppServices()
  const [list, setList] = useState([])

  const [apps, setApps] = useState([])
  const [loader, setLoader] = useState(true)
  const getCategories = async () => {
    const { response } = await AppService.AppsChecklist.get_category({
      toaster: false,
    })
    if (response) {
      setList(response?.data?.filter(item => item.app_id === appId))

    } else {
      setApps([])
    }
    setLoader(false)
  }


  const getAppName = async () => {
    const { response } = await AppService.AppsChecklist.get_app_name({
      toaster: false,
    })
    if (response) {
      setApps(response?.data)
    } else {
      setApps([])
    }
    setLoader(false)
  }




  const onLoad = () => {
    getAppName()
    getCategories()
  }

  const handleDelete = async (id) => {
    const { response } = await AppService.AppsChecklist.delete_category({
      query: `_id=${id}`,
    })
    if (response) onLoad()
  }

  useEffect(onLoad, [])

  return {
    loader: loader,
    apps: apps,
    handleRefresh: onLoad,
    dataTableData: {
      columns: [
        { Header: 'Name', accessor: 'name' },
        { Header: 'App Name', accessor: 'app_name' },
        { Header: 'Type', accessor: 'type' },

        { Header: 'Action', accessor: 'action' },
      ],
      rows: list.map((data) => ({
        name: data?.name,
        app_name: data?.app_name,
        type: data?.type,

        action: (
          <MDBox>
            <EditModal data={data} handleRefresh={onLoad} apps={apps} />
            <MDButton
              variant="contained"
              color="error"
              size="small"
              sx={{ marginLeft: 2 }}
              onClick={() => handleDelete(data?._id)}
            >
              Delete
            </MDButton>
          </MDBox>
        ),
      })),
    },
  }
}
